import React from 'react';
import styled from 'styled-components';
//
import SocialIcons from 'components/social-icons';
//
import Locations from './locations';
import MainLink from './main-link';
import Microsite from './microsite';
//
export default ({ menu, microsite }) => {
  return (
    <Wrap>
      {!microsite && (
        <List>
          {menu && menu.map(link => <MainLink key={link.id} {...link} />)}
        </List>
      )}
      {microsite && <Microsite {...microsite} />}
      <SocialIcons />
      <Locations />
    </Wrap>
  );
};
//
const Wrap = styled.nav`
  background-color: #fff;
  grid-area: navigation;
  line-height: 1;
  margin: 1vw 0;
  padding: 0 0 4rem;
  width: 100%;
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;
